<template>
    <div>
        <div v-if="announcements.length">
            <div style="margin-bottom:15px"><router-link style="text-decoration:none" class="my-checklists-label" to="/announcements">Announcements</router-link></div>
            <div class="announcements" style="width:100%;padding:0;margin-bottom:24px;">
                <div v-for="(an, i) in announcements" :key="i">
                    <div><i>{{ an.DateDisplay }} - {{ an.Location }}</i></div>
                    <div v-html="an.TextDisplay" style="max-width: 920px"></div>
                    <div><b>&nbsp;&nbsp;- {{ an.CreatedBy }}</b></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'AnnouncementsHomeNode',
    props: [  ],
    components: {
        
    },
    data() {
        return {
            announcements: [] as any
        }
    },
    created() {
        axios.get(`${this.$store.state.apiUrl}/api/announcements?startDate=${new Date(new Date().getTime() - (86400000 * 14))}`,)
            .then(resp => {
                for(const an of resp.data) {
                    an.DateDisplay = new Date(an.Date).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
                    an.TextDisplay = an.Text.replace(/\n/g, '<br/>');
                }
                if(resp.data.length) {
                    this.announcements = resp.data;
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
});
</script>